
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
import {
  GetKnowledgeList,
  DelKnowledge,
  EditKnowledge,
  getAllInspect,
  getZhibiaoList,
  GetZidian,
  editZhibiao,
  delZhibiao,
} from "@/request/content";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class Name extends mixins(listMixin) {
  private ifShowEdit: any = false;
  private editData: any = {
    检验项目: [],
    参考值: ["", ""],
  };
  private window: any = window;
  private data: any[] = [];
  private types: any = [];
  private jianyanxiangmus: any = [];
  private leixing: any = [];
  private danwei: any = [];
  private H: any = "";
  private forceUpdate() {
    this.$forceUpdate();
  }
  private switchChange(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    editZhibiao(this, item, loading)
      .then((res: any) => {
        loading.close();
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getJianyanxiangmu(d: any) {
    let str: any = "";
    if (d.length > 0) {
      d.forEach((ele: any, index: any) => {
        if (index > 0) {
          str += "、";
        }
        str += ele.inspect_name;
      });
    }
    return str;
  }
  private getCankaozhi(val: any) {
    let text: any = "";
    if (val && val.length > 0) {
      val.forEach((ele: any, index: any) => {
        if (index > 0) {
          text += "，";
        }
        text += ele["适用范围"] + "：" + ele["下限值"] + "—" + ele["上限值"];
      });
    }
    return text;
  }
  private addOne() {
    if (!this.editData["参考值"]) {
      this.editData["参考值"] = [];
    }
    // 每次添加的时候验证最后一个的数据
    if (this.editData["参考值"].length > 0) {
      const d = this.editData["参考值"][this.editData["参考值"].length - 1];
      if (!d["适用范围"]) {
        this.$message.warning("请输入适用范围");
        return;
      }
      if (!(d["下限值"] < d["上限值"])) {
        this.$message.warning("下限值必须小于上限值");
        return;
      }
    }
    const obj: any = {
      上限值: null,
      下限值: null,
      适用范围: "",
    };
    this.editData["参考值"].push(obj);
    this.forceUpdate();
  }
  private delOne(index: any) {
    this.editData["参考值"].splice(index, 1);
    this.forceUpdate();
  }
  private getType(type: any, key: any) {
    const params: any = {
      data_type: type,
    };
    GetZidian(this, params).then((res: any) => {
      this[key] = res[type];
    });
  }
  private remoteMethod(e: any) {
    const params: any = {
      params: {
        inspect_type: "checkout",
        inspect_name: e,
      },
    };
    getAllInspect(this, params).then((res: any) => {
      this.jianyanxiangmus = res;
    });
  }
  private openEdit(item?: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
      // 处理参考值
      if (this.editData.interval) {
        const arr = this.editData.interval.split("~");
        this.editData["参考值"] = [arr[0], arr[1]];
      } else {
        this.editData["参考值"] = ["", ""];
      }
    } else {
      this.editData = {
        参考值: ["", ""],
        检验项目: [],
      };
    }
    this.remoteMethod("");
    this.ifShowEdit = true;
  }
  private editSure() {
    if (!this.editData["index_name"]) {
      this.$message.warning("请输入指标名称！");
      return;
    }
    if (this.editData["检验项目"].length == 0) {
      this.$message.warning("请选择检验项目！");
      return;
    }
    if (!this.editData["data_type"]) {
      this.$message.warning("请选择取值类型！");
      return;
    }
    if (this.editData["参考值"][0] && !this.editData["参考值"][1]) {
      this.$message.warning("请输入上限值");
      return;
    }
    if (this.editData["参考值"][1] && !this.editData["参考值"][0]) {
      this.$message.warning("请输入下限值");
      return;
    }
    if (
      this.editData["参考值"][0] &&
      this.editData["参考值"][1] &&
      !(this.editData["参考值"][0] < this.editData["参考值"][1])
    ) {
      this.$message.warning("下限值必须小于上限值");
      return;
    }
    let d: any = JSON.parse(JSON.stringify(this.editData));
    if (d["参考值"][0]) {
      d.interval = d["参考值"][0] + "~" + d["参考值"][1];
    } else {
      d.interval = "";
    }
    delete d["参考值"];
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    editZhibiao(this, d, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success(this.editData.id ? "编辑" : "新增" + "成功");
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  /**
   * @description 删除
   */
  private deleteOne(item: any, index: any) {
    this.$confirm("确定删除该条记录么？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          index_id: item.index_id,
        },
      };
      delZhibiao(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("删除成功");
          if (this.data.length === 1 && this.filters.current_page !== 1) {
            this.filters.current_page--;
          }
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      temp_id: this.filters["检验项目"].temp_id,
      index_name: this.filters.search,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
      sort_value: "-1",
      sort_key: "update_time",
    };
    localStorage.setItem("zhibiaokuFilter", JSON.stringify(this.filters));
    getZhibiaoList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "更新时间";
    this.filters.sort_value = 1;
    this.filters["检验项目"] = {};
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("zhibiaokuFilter")) {
      this.filters = JSON.parse(localStorage.getItem("zhibiaokuFilter") as any);
    }
    this.getList();
  }
}
